import type { FunctionComponent, ReactNode } from 'react';
import GenericInfoDTO from '../../../interfaces/dto/genericInfoDTO';
import Question from '../../../interfaces/question';
import { ChosenOptionAnswer } from '../../context/SurveyPageContext';
import RadioHtmlOption from './RadioHtmlOption';
import * as styles from './RadioHtml.module.css';

export interface RadioButtonProps {
  question: Question;
  onChange: (newValue: number) => void;
  radioButtonAnswer: ChosenOptionAnswer | undefined;
  htmlOption: (options: GenericInfoDTO) => ReactNode;
}

const RadioHtml: FunctionComponent<RadioButtonProps> = ({
  question,
  onChange,
  radioButtonAnswer,
  htmlOption,
}) => {
  const options = question.radioButtonOptions;
  const radioOptionId = radioButtonAnswer?.chosenOption?.id;

  return (
    <div className={`${styles.radioHmtlContainer}`}>
      {options.map((option) => (
        <RadioHtmlOption
          option={option}
          questionId={question.id}
          onChange={onChange}
          checked={radioOptionId === option.id}
          key={`radioHtmlOption-${option.id}`}
          grayedOut={!!(radioOptionId && radioOptionId !== option.id)}
        >
          {htmlOption(option)}
        </RadioHtmlOption>
      ))}
    </div>
  );
};

export default RadioHtml;
